import { Consents } from '../types';

// The API boundary between the four consent booleans and the submit's array shape
// (backend-plan.md §7.2) — not a straight rename, so kept explicit rather than assumed.
const CONSENT_KIND_MAP: Record<keyof Consents, string> = {
  accuracy: 'accuracy',
  cgvMandate: 'terms_and_mandate',
  earlyExecution: 'immediate_execution',
  independenceFromAnts: 'private_service',
};

const CONSENT_TEXT_VERSION = '2026-09-16';

const CONSENT_TEXT_VERSION_MINOR = '2026-09-16-minor';

const MAJORITY_AGE = 18;

const isMinorBirthDate = (birthDate?: string): boolean => {
  if (!birthDate) {
    return false;
  }

  const parsed = new Date(birthDate);

  if (Number.isNaN(parsed.getTime())) {
    return false;
  }

  const majority = new Date(parsed.getTime());
  majority.setFullYear(majority.getFullYear() + MAJORITY_AGE);

  return majority > new Date();
};

const textVersionFor = (key: keyof Consents, isMinor: boolean): string => (
  key === 'cgvMandate' && isMinor ? CONSENT_TEXT_VERSION_MINOR : CONSENT_TEXT_VERSION
);

const mapConsentsToPayload = (consents: Consents, isMinor = false) => (
  Object.keys(CONSENT_KIND_MAP) as (keyof Consents)[]
).filter((key) => consents[key]).map((key) => ({
  kind: CONSENT_KIND_MAP[key],
  text_version: textVersionFor(key, isMinor),
}));

const mapSubmitPayload = (consents: Consents, password?: string, isMinor = false) => ({
  password,
  consents: mapConsentsToPayload(consents, isMinor),
});

export {
  CONSENT_TEXT_VERSION,
  CONSENT_TEXT_VERSION_MINOR,
  isMinorBirthDate,
  mapConsentsToPayload,
  mapSubmitPayload,
};
